import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";

import {Organization} from "../model/Organization";

@Injectable({
  providedIn: "root"
})
export class OrganizationService {

  public constructor(private readonly _httpClient: HttpClient) {}

  public loadOrganization(organizationId: string): Promise<Organization> {
    return this._httpClient.get<Organization>("api/organizations/" + organizationId).toPromise();
  }

  public submitLicenseRequest(organization: Organization): Promise<void> {
    return this._httpClient.post<void>("api/licenseRequests", organization).toPromise();
  }

}
